import NewStruct from './NewStruct';
export default NewStruct;